import JassEnum from './enum';

/**
 * type itemtype
 */
export default class JassItemType extends JassEnum {}
